module.exports = __webpack_public_path__ + "images/apple-touch-icon-164330f2.png";